import React from "react";
import "./LayoutSettings.css";

const LayoutSettings = ({ isOpen, onClose, layoutOption, setLayoutOption }) => {
  if (!isOpen) return null;

  return (
    <div
      className="layout-modal-overlay"
      onClick={onClose}
    >
      <div
        className="layout-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="layout-modal-close"
          onClick={onClose}
        >
          ×
        </button>
        <h2 className="layout-modal-title">Layout Settings</h2>
        <p className="layout-modal-subtitle">Customize your workspace for speed, comfort, and control.</p>
        <div className="layout-option-grid">
          {[
            {
              id: "option-1",
              label: "Layout 1",
              bars: ["menu", "controls", "editor"],
            },
            {
              id: "option-2",
              label: "Layout 2",
              bars: ["menu", "editor", "controls"],
            },
            {
              id: "option-3",
              label: "Layout 3",
              bars: ["editor", "controls", "menu"],
            },
            {
              id: "option-4",
              label: "Layout 4",
              bars: ["controls", "editor", "menu"],
            },
          ].map((option) => (
            <button
              key={option.id}
              className={`layout-option-card ${
                layoutOption === option.id ? "active" : ""
              }`}
              onClick={() => setLayoutOption(option.id)}
            >
              <div className="layout-option-visual">
                {option.bars.map((bar, index) => (
                  <span
                    key={`${option.id}-${bar}-${index}`}
                    className={`layout-option-bar layout-option-bar--${bar}`}
                  />
                ))}
              </div>
              <div className="layout-option-text">
                <span className="layout-option-title">{option.label}</span>
              </div>
            </button>
          ))}
        </div>
        <div className="layout-modal-footer">
          <button
            className="layout-modal-apply-btn"
            onClick={onClose}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default LayoutSettings;
